import React from 'react'

function RedPay() {
    return (
        <svg 
            fill="#ff0000" 
            width="40px" 
            height="40px" 
            viewBox="0 0 256 256" 
            id="Flat" 
            xmlns="http://www.w3.org/2000/svg" 
            stroke="#ff0000"
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
            <g id="SVGRepo_iconCarrier"> 
                <path d="M152,128c0,14.85938-5.05469,40-24,40s-24-25.14062-24-40,5.05469-40,24-40S152,113.14062,152,128Zm72-80V208a16.02085,16.02085,0,0,1-16,16H48a16.02085,16.02085,0,0,1-16-16V48A16.02085,16.02085,0,0,1,48,32H208A16.02085,16.02085,0,0,1,224,48Zm-56,80c0-27.875-12.36719-56-40-56s-40,28.125-40,56,12.36719,56,40,56S168,155.875,168,128Z" />
            </g>
        </svg>
    )
}

export default RedPay